import { cn } from '@app/utils/cn';

import { Skeleton } from '../Skeleton';

interface Props {
  className?: string;
  orientation?: 'vertical' | 'horizontal';
}

export const AttributeSkeleton = ({ orientation, className }: Props) => (
  <div className={cn('body-1', { 'flex flex-col gap-1': orientation === 'vertical' }, className)}>
    <dt className="w-full max-w-24">
      <Skeleton type="text" size="medium" />
    </dt>
    <dd>
      <Skeleton type="text" size="medium" />
    </dd>
  </div>
);
